import type { FunctionComponent } from "react";

import encourageImage from "./encourage.png";
import highQualityContentImage from "./high-quality-content.png";
import learningByDoingImage from "./learning-by-doing.png";
import {
  Container,
  Description,
  Header,
  HeaderContainer,
  ItemContainer,
  StyledSandTwo,
  StyledWhyPostiesItem,
} from "./styles";

type Props = {
  id: string;
};

export const WhyPosties: FunctionComponent<Props> = ({ id }) => {
  const items = [
    {
      description:
        "As a globally trusted English-language news source, our content is created by experts who know exactly what your children need to improve their language skills.",
      image: highQualityContentImage,
      title: "High-quality content",
    },
    {
      description:
        "Learning should be an interactive experience. Our inclusive and fun activities help your children develop their English while keeping them engaged.",

      image: learningByDoingImage,
      title: "Hands-on activities",
    },
    {
      description:
        "Instead of a one-way teaching approach, we encourage children to take charge of their own learning journey.",
      image: encourageImage,
      title: "A child-led approach",
    },
  ];

  return (
    <Container id={id}>
      <HeaderContainer>
        <Header>Why Posties?</Header>
        <Description>
          A fun educational product that helps your child discover new knowledge about themselves
          and the world
        </Description>
      </HeaderContainer>
      <ItemContainer>
        {items.map((item, index) => (
          <StyledWhyPostiesItem {...item} key={index} />
        ))}
      </ItemContainer>
      <StyledSandTwo />
    </Container>
  );
};

WhyPosties.displayName = "WhyPosties";
